import FilterSettings from './FilterSettings';

export default FilterSettings;
